import { render, staticRenderFns } from "./BlogCustomer.vue?vue&type=template&id=dcf8c23c&"
import script from "./BlogCustomer.vue?vue&type=script&lang=js&"
export * from "./BlogCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports